import React from 'react';
import List from '../components/list';
import UnitsLike from './units-like';

const RelatedUnits = (props) => {
  const { RelatedUnits, MoreUnitsLike, Translations } = props;
  const matomoTrackingClass = 'relaterade-mottagningar';
  return (
    <div className="related-units">
      {RelatedUnits && RelatedUnits.length > 0 && (
        <List items={RelatedUnits} matomoTrackingClass={matomoTrackingClass} fullWidth={true} />
      )}
      {MoreUnitsLike && MoreUnitsLike.length > 0 && (
        <UnitsLike items={MoreUnitsLike} Translations={Translations} />
      )}
    </div>
  );
};

export default RelatedUnits;
